// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import type { PluginListenerHandle } from "@capacitor/core";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Capacitor } from "@capacitor/core";
// Pre-existing native import - exempt from multi-version OTA adapter layer requirement.
// New usages should be migrated to the adapter layer.
// eslint-disable-next-line no-restricted-imports
import { Keyboard } from "@capacitor/keyboard";
import { type RefObject, useEffect } from "react";

export function useScrollToViewOnKeyboard(
  elementRef: RefObject<HTMLElement | HTMLInputElement | undefined>
) {
  useEffect(() => {
    let keyboardDidShowListener: PluginListenerHandle;

    async function bindListeners() {
      keyboardDidShowListener = await Keyboard.addListener("keyboardDidShow", () => {
        elementRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    }

    if (Capacitor.isNativePlatform()) {
      void bindListeners();
    }

    return () => {
      void keyboardDidShowListener?.remove();
    };
  }, [elementRef]);
}
